// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueCalendly from 'vue-calendly'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import vClickOutside from 'v-click-outside'

import '../metrics'
import '../registerServiceWorker'

import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'

consoleBuildInfo()

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(vClickOutside)
Vue.use(VueCalendly)

Vue.use(ColorThemePlugin, {
  primary: '#1668D3',
  secondary: '#43ced9',
  danger: '#f8706d',
  info: '#004EB9',
  success: '#8ddc88',
  warning: '#ffd652',
  gray: '#8396a5',
  darkerGray: '#5D707F',
  white: '#fff',
  black: '#000',
  fontColor: '#34495e',
  transparent: 'transparent',
  lighterGray: '#ddd',
})

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
  Vue.nextTick(() => {
    document.title = to.meta.title
    const descriptionElement = document.querySelector('head meta[name="description"]')
    const robotsElement = document.querySelector('head meta[name="robots"]')
    descriptionElement.setAttribute('content', to.meta.description)
    robotsElement.setAttribute('content', to.meta.robots)
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
